import { Component, OnInit, Input, AfterViewInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { JssStylingService } from '../../jss-styling.service';
import Swiper from 'swiper';
import { ThemeService } from '../../services/theme.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-generic-product-gallery',
  templateUrl: './generic-product-gallery.component.html',
  styleUrls: ['./generic-product-gallery.component.scss']
})
export class GenericProductGalleryComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() rendering: ComponentRendering;
  @ViewChild('CardSlider', { static: false }) swiperSlider!: ElementRef;
  dynamicClass: string;
  swiper: Swiper;
  shownItems = 3;
  private energySubscription: Subscription;
  public energySaveMode:boolean;

  constructor(public jssStylingService: JssStylingService, private themeService: ThemeService) { }
  
  ngOnInit() {
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
    this.energySubscription = this.themeService.isEnegySaveModeEnabled().subscribe((energySave) => {
      this.energySaveMode = energySave;
    });
  }

  ngAfterViewInit() {
    var _this = this;
    this.swiper = new Swiper(this.swiperSlider?.nativeElement, {
      enabled: true,
      slidesPerView: "auto",
      freeMode: true,
      centeredSlides: false,
      spaceBetween: 24,
      grabCursor: true,
      breakpoints: {
        1024: {
          enabled: false,
        },
      },
      on: {
        activeIndexChange: function() {
          if(_this.swiper.activeIndex == _this.shownItems - 2){
            _this.shownItems = _this.shownItems + 3;
          }
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.energySubscription.unsubscribe();
  }
}
